import React, {useEffect} from "react";
import {useLocation, useParams} from "react-router-dom";
import {useReadContactDetail} from "../hooks";
import useGoToNavigation from "../../../../util/useGotoNavigation";
import {SubmitHandler, useForm, useWatch} from "react-hook-form";
import useSaveContact from "../hooks/useSaveContact";
import {useEditMode, useModal} from "../../../../hooks";
import {ContactSaveType} from "../interface";
import useReadContactPathSelectBox from "../hooks/useReadContactPathSelectBox";
import {SearchBusinessPartnerInner} from "../../../../components/common/modal/inner/SearchBusinessPartnerInner";
import {useReadIndustrySelectBox} from "../../correspondent/detail/hooks";
import useDeleteContact from "../hooks/useDeleteContact";
import SearchUserInner from "../../../../components/common/modal/inner/SearchUserInner";
import AuthorityChecker from "../../../../components/common/authorityGuard/AuthorityChecker";
import {useUser} from "../../../../util/userContext/UserContext";

type Props = {
    isCreate: boolean;
};

export const ContactDetail = ({isCreate}: Props) => {
    const location = useLocation();
    const params = useParams();

    // 내부수정: 새창(state 없음)일 때 sessionStorage에서 복구
    const searchDetailOption = location?.state ?? (() => {
        try {
            const key = `nav_state:customer/contact/detail/${params?.id}`;
            const raw = sessionStorage.getItem(key);
            if (raw) {
                return JSON.parse(raw);
            }
        } catch {}
        return undefined;
    })();

    const {user} = useUser()
    const {goToNavigation} = useGoToNavigation();
    const {setRead, setCreate, setUpdate, mode} = useEditMode();
    const {handleModal, resetModal} = useModal();

    const {mutate: deleteMutate} = useDeleteContact({});
    const {mutate} = useSaveContact({setRead, isCreate});

    const {data} = useReadContactDetail({
        // searchDetailOption: location?.state,
        searchDetailOption: searchDetailOption,
        isCreate: isCreate,
    });
    const {data: contactPathData} = useReadContactPathSelectBox();
    const {data: industrySelect} = useReadIndustrySelectBox();

    const defaultValue = {
        companyName: "",
        contactPath: "",
        contactid: "",
        createBy: "",
        createdOn: "",
        department: "",
        description: "",
        emailAddress1: "",
        emailAddress2: "",
        fax: "",
        userId: 0,
        userName: "",
        fullName: "",
        industryCategory: "",
        jobTitle: "",
        mobilePhone: "",
        newChkEmailAddress1: "true",
        newChkEmailAddress2: "true",
        newLContactpathValue: "",
        newLIndustryGlobalValue: "",
        newTxtTeam: "",
        parentcustomeridValue: "",
        stateCode: 0,
        stateCodeName: "",
        telephone1: "",
    };

    const {register, handleSubmit, control, reset, setValue} = useForm({
        defaultValues: defaultValue,
    });

    const onSubmit: SubmitHandler<ContactSaveType> = (submitData) => {
        if (submitData.fullName.trim().length === 0) {
            handleModal({
                isOpen: true,
                contents: "이름을 입력해주세요.",
                type: "alert",
            })

            return;
        }
        if (submitData.jobTitle?.trim().length === 0) {
            handleModal({
                isOpen: true,
                contents: "직함을 입력해주세요.",
                type: "alert",
            })

            return;
        }
        if (submitData.parentcustomeridValue?.trim().length === 0) {
            handleModal({
                isOpen: true,
                contents: "회사명을 선택해주세요.",
                type: "alert",
            })

            return;
        }
        if (submitData.newLIndustryGlobalValue?.trim().length === 0) {
            handleModal({
                isOpen: true,
                contents: "산업구분을 선택해주세요.",
                type: "alert",
            })

            return;
        }
        if (submitData.newTxtTeam?.trim().length === 0) {
            handleModal({
                isOpen: true,
                contents: "팀을 입력해주세요.",
                type: "alert",
            })

            return;
        }
        if (submitData.mobilePhone?.trim().length === 0) {
            handleModal({
                isOpen: true,
                contents: "휴대폰을 입력해주세요.",
                type: "alert",
            })

            return;
        }
        if (submitData.emailAddress1?.trim().length === 0) {
            handleModal({
                isOpen: true,
                contents: "회사 이메일을 입력해주세요.",
                type: "alert",
            })

            return;
        }
        if (submitData.newLContactpathValue?.trim().length === 0) {
            handleModal({
                isOpen: true,
                contents: "컨택 경로를 선택해주세요.",
                type: "alert",
            })

            return;
        }

        mutate(submitData);
    };

    const watches = {
        ...defaultValue,
        ...useWatch<ContactSaveType>({control}),
    };

    useEffect(() => {
        if (isCreate) {
            setCreate();
        } else {
            if (data) {
                reset(data);
            }
        }
    }, [isCreate]);

    return (
        <>
            <div className="content_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">연락처 {mode === "C" ? "생성" : "상세보기"}</h3>
                    <div className="filter_toolbar">
                        {mode === "R" ? (
                            <>
                                <button
                                    className="btn btn-outline-primary w-100px h-38px"
                                    onClick={() => {
                                        goToNavigation("customer/contact/list", {}, true);
                                    }}
                                >
                                    <img
                                        src={
                                            process.env.PUBLIC_URL +
                                            "/assets/images/icon_hamburger_btn.png"
                                        }
                                        alt=""
                                    />
                                    목록
                                </button>
                                <AuthorityChecker authorityNames={['contactWriteYn']}>
                                    <button
                                        className="btn btn-secondary w-100px h-38px"
                                        onClick={() => {
                                            setUpdate();
                                            reset(data as ContactSaveType);
                                        }}
                                    >
                                        수정
                                    </button>
                                    <button
                                        className="btn btn-outline-dark w-100px h-38px"
                                        onClick={() => {
                                            handleModal({
                                                isOpen: true,
                                                contents: "삭제하시겠습니까?",
                                                type: "confirm",
                                                callback: () => {
                                                    if (params?.id) {
                                                        deleteMutate([
                                                            {
                                                                id: params?.id as string,
                                                            },
                                                        ]);
                                                    }
                                                }
                                            })
                                        }}
                                    >
                                        <img
                                            src={
                                                process.env.PUBLIC_URL + "/assets/images/icon_cross.png"
                                            }
                                            alt=""
                                        />
                                        삭제
                                    </button>
                                </AuthorityChecker>
                            </>
                        ) : (
                            <>
                                <button
                                    className="btn btn-primary w-100px h-38px"
                                    onClick={handleSubmit(onSubmit)}
                                >
                                    저장
                                </button>
                                <button
                                    className="btn btn-outline-secondary w-100px h-38px"
                                    onClick={() => {
                                        if (isCreate) {
                                            goToNavigation(-1, {}, true);
                                        } else {
                                            setRead();
                                            reset();
                                        }
                                    }}
                                >
                                    취소
                                </button>
                            </>
                        )}
                    </div>
                </div>
                <h5 className="subheading">연락처 정보</h5>
                <div className="table_scroll mb-0">
                    <table className="table table-bordered my_table table_detail">
                        <tbody>
                        <tr>
                            <th style={{width: "16.66%"}}>이름</th>
                            <td colSpan={3}>
                                {isCreate ? watches.fullName : data?.fullName}
                            </td>
                        </tr>
                        <tr>
                            <th style={{width: "16.66%"}}>생성일자</th>
                            <td style={{width: "33.34%"}}>{data?.createdOn}</td>
                            <th style={{width: "16.66%"}}>생성자</th>
                            <td>{data?.createBy}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="content_wrap">
                <h5 className="subheading mt-0">연락처 상세정보</h5>
                <div className="table_scroll mb-0">
                    <table className="table table-bordered my_table table_detail">
                        <tbody>
                        <tr>
                            <th style={{width: "16.66%"}}>계정</th>
                            <td className={mode !== "R" ? "p-4px" : ""} style={{width: "33.34%"}}>
                                {mode === "R" ? (
                                    data?.userName
                                ) : (
                                    <div className="d-flex">
                                        <input
                                            type="text"
                                            className="form-control"
                                            {...register("userName")}
                                            disabled
                                        />
                                        <button
                                            className="btn btn-info btn_search ms-5px"
                                            onClick={() =>
                                                handleModal({
                                                    isOpen: true,
                                                    contents: (
                                                        <SearchUserInner
                                                            confirmCallback={(item) => {
                                                                setValue("userId", item.userId);
                                                                setValue("userName", item.userName);
                                                            }}
                                                            modalDepth={1}
                                                        />
                                                    ),
                                                    type: "",
                                                    title: "사용자 조회",
                                                    modalSize: "xxl",
                                                })
                                            }
                                        >
                                            <img
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    "/assets/images/icon_search.png"
                                                }
                                                alt=""
                                            />
                                            찾기
                                        </button>
                                    </div>
                                )}
                            </td>
                            <th style={{width: "16.66%"}}>이름 {mode !== "R" && <span className="required">*</span>}</th>
                            <td className={mode !== "R" ? "p-4px" : ""} style={{width: "33.34%"}}>
                                {mode === "R" ? (
                                    data?.fullName
                                ) : (
                                    <input className="form-control" {...register("fullName")} />
                                )}
                            </td>
                        </tr>
                        <tr>
                            <th style={{width: "16.66%"}}>직함 {mode !== "R" && <span className="required">*</span>}</th>
                            <td className={mode !== "R" ? "p-4px" : ""} style={{width: "33.34%"}}>
                                {mode === "R" ? (
                                    data?.jobTitle
                                ) : (
                                    <input className="form-control" {...register("jobTitle")} />
                                )}
                            </td>
                            {/* 내부수정: 컨택경로 * 삭제 */}
                            <th>컨택 경로 {mode !== "R" && <span className="required">*</span>}</th>
                            <td className={mode !== "R" ? "p-4px" : ""}>
                                {mode === "R" ? (
                                    data?.contactPath
                                ) : (
                                    <select
                                        className="form-select"
                                        {...register("newLContactpathValue")}
                                    >
                                        <option value={""} hidden>선택</option>
                                        {contactPathData?.map((item) => {
                                            return <option value={item?.id}>{item?.name}</option>;
                                        })}
                                    </select>
                                )}
                            </td>
                        </tr>
                        <tr>
                            <th>회사명 {mode !== "R" && <span className="required">*</span>}</th>
                            <td className={mode !== "R" ? "p-4px" : ""}>
                                {/*<AuthorityChecker authorityNames={['clientReadYn']}>*/}
                                {mode === "R"
                                    ? <>{user?.authority.clientReadYn === "Y"
                                        ? <a href={void 0} className="link-underline"
                                                onClick={() => goToNavigation(`customer/correspondent/detail/${data?.parentcustomeridValue}`, {
                                                    accountId: data?.parentcustomeridValue,
                                                    chargeName: null,
                                                    customerCategoryName: null,
                                                    defaultContact: null,
                                                    erpAccountCode: null,
                                                    erpAccountName: null,
                                                    industryName: null,
                                                    name: data?.companyName,
                                                    stateCodeName: data?.stateCodeName,
                                                    stateCode: data?.stateCode
                                               }, false)}>{data?.companyName}</a>
                                        : data?.companyName}</>
                                    : (<div className="d-flex">
                                            <input
                                                type="text"
                                                className="form-control"
                                                {...register("companyName")}
                                                disabled
                                            />
                                            <button
                                                className="btn btn-info btn_search ms-5px"
                                                onClick={() =>
                                                    handleModal({
                                                        isOpen: true,
                                                        contents: (
                                                            <SearchBusinessPartnerInner
                                                                confirmCallback={(item) => {
                                                                    setValue(
                                                                        "parentcustomeridValue",
                                                                        item?.accountId
                                                                    );
                                                                    setValue("companyName", item?.name);
                                                                }}
                                                                modalDepth={1}
                                                            />
                                                        ),
                                                        type: "",
                                                        title: "고객사 조회",
                                                        modalSize: "xxl",
                                                    })
                                                }
                                            >
                                                <img
                                                    src={
                                                        process.env.PUBLIC_URL +
                                                        "/assets/images/icon_search.png"
                                                    }
                                                    alt=""
                                                />
                                                찾기
                                            </button>
                                        </div>
                                    )}
                            </td>
                            <th>산업구분 {mode !== "R" && <span className="required">*</span>}</th>
                            <td className={mode !== "R" ? "p-4px" : ""}>
                                {mode === "R" ? (
                                    data?.industryCategory
                                ) : (
                                    <select
                                        className="form-select"
                                        {...register("newLIndustryGlobalValue")}
                                    >
                                        <option value={""} hidden>선택</option>
                                        {industrySelect?.map((item) => {
                                            return <option value={item.id}>{item?.name}</option>;
                                        })}
                                    </select>
                                )}
                            </td>
                        </tr>
                        <tr>
                            <th>부서</th>
                            <td className={mode !== "R" ? "p-4px" : ""}>
                                {mode === "R" ? (
                                    data?.department
                                ) : (
                                    <input
                                        className="form-control"
                                        {...register("department")}
                                    />
                                )}
                            </td>
                            <th>팀 {mode !== "R" && <span className="required">*</span>}</th>
                            <td className={mode !== "R" ? "p-4px" : ""}>
                                {mode === "R" ? (
                                    data?.newTxtTeam
                                ) : (
                                    <input
                                        className="form-control"
                                        {...register("newTxtTeam")}
                                    />
                                )}
                            </td>
                        </tr>
                        <tr>
                            <th>근무처 전화</th>
                            <td className={mode !== "R" ? "p-4px" : ""}>
                                {mode === "R" ? (
                                    data?.telephone1
                                ) : (
                                    <input
                                        className="form-control"
                                        {...register("telephone1")}
                                    />
                                )}
                            </td>
                            <th>휴대폰 {mode !== "R" && <span className="required">*</span>}</th>
                            <td className={mode !== "R" ? "p-4px" : ""}>
                                {mode === "R" ? (
                                    data?.mobilePhone
                                ) : (
                                    <input
                                        className="form-control"
                                        {...register("mobilePhone")}
                                    />
                                )}
                            </td>
                        </tr>
                        <tr>
                            <th>팩스</th>
                            <td className={mode !== "R" ? "p-4px" : ""}>
                                {mode === "R" ? (
                                    data?.fax ?? "-"
                                ) : (
                                    <input className="form-control" {...register("fax")} />
                                )}
                            </td>
                            <th></th>
                            <td></td>
                        </tr>
                        <tr>
                            <th>회사 이메일 {mode !== "R" && <span className="required">*</span>}</th>
                            <td className={mode !== "R" ? "p-4px" : ""}>
                                {mode === "R" ? (
                                    data?.emailAddress1
                                ) : (
                                    <input
                                        className="form-control"
                                        {...register("emailAddress1")}
                                    />
                                )}
                            </td>
                            <th>회사 이메일 수신여부</th>
                            <td className={mode !== "R" ? "p-4px" : ""}>
                                {mode === "R" ? (
                                    data?.newChkEmailAddress1 === "true" ? (
                                        "수신"
                                    ) : (
                                        "미수신"
                                    )
                                ) : (
                                    <select className="form-select" {...register("newChkEmailAddress1")}>
                                        <option value="false">미수신</option>
                                        <option value="true">수신</option>
                                    </select>
                                )}
                            </td>
                        </tr>
                        <tr>
                            <th>개인 이메일</th>
                            <td className={mode !== "R" ? "p-4px" : ""}>
                                {mode === "R" ? (
                                    data?.emailAddress2 ?? "-"
                                ) : (
                                    <input
                                        className="form-control"
                                        {...register("emailAddress2")}
                                    />
                                )}
                            </td>
                            <th>개인 이메일 수신여부</th>
                            <td className={mode !== "R" ? "p-4px" : ""}>
                                {mode === "R" ? (
                                    data?.newChkEmailAddress2 === "true" ? (
                                        "수신"
                                    ) : (
                                        "미수신"
                                    )
                                ) : (
                                    <select className="form-select" {...register("newChkEmailAddress2")}>
                                        <option value="false">미수신</option>
                                        <option value="true">수신</option>
                                    </select>
                                )}
                            </td>
                        </tr>
                        <tr>
                            <th>메모</th>
                            <td className={mode !== "R" ? "p-4px" : ""} colSpan={3}>
                                {mode === "R" ? (
                                    data?.description
                                ) : (
                                    <input
                                        type="text"
                                        className="form-control"
                                        {...register("description")}
                                    />
                                )}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};
